<template>
	<div class="BaseOrdersLocationsDD">
		<div class="mdms">
			<!-- <div v-if="selected.length" class="display__selected">
				<span
					v-for="(item, index) in selected"
					:key="index"
					class="mdms__selected"
					@click="removeFromSelectedArray(item)"
				>
					<span class="mdms__selected--val text-sm">
						{{ item.name }}
					</span>
					<i class="el-icon-close pt-1 text-xs" />
				</span>
			</div> -->
			<nav class="main_nav">
				<!-- <label>Select Location</label> -->
				<ul>
					<li>
						<div class="mdms__input">
							<input type="text" placeholder="select location" />
						</div>

						<ul>
							<li v-for="(level1, index1) in orderlocations" :key="index1">
								<div class="displayVal" @click="extractOutlets($event, level1)">
									<!-- {{ level1 }} -->
									<span>{{ level1.name }}</span>
									<i v-if="level1.isSelected" class="el-icon-check text-xs" />
								</div>
								<ul v-if="level1.hasOwnProperty('regions')">
									<li
										v-for="(level2, index2) in level1.regions.length > 0
											? level1.regions
											: level1.outlets"
										:key="index2"
									>
										<div
											class="displayVal"
											@click="extractOutlets($event, level2)"
										>
											<span>{{ level2.name }}</span>
											<i
												v-if="level2.isSelected"
												class="el-icon-check text-xs"
											/>
										</div>
										<ul v-if="level2.hasOwnProperty('subregions')">
											<li
												v-for="(level3, index3) in level2.subregions.length > 0
													? level2.subregions
													: level2.outlets"
												:key="index3"
											>
												<div
													class="displayVal"
													@click="extractOutlets($event, level3)"
												>
													<span>{{ level3.name }}</span>
													<i
														v-if="level3.isSelected"
														class="el-icon-check text-xs"
													/>
												</div>
												<ul v-if="level3.hasOwnProperty('outlets')">
													<li
														v-for="(level4, index4) in level3.outlets"
														:key="index4"
													>
														<div
															class="displayVal"
															@click="extractOutlets($event, level4)"
														>
															<span>{{ level4.name }}</span>
															<i
																v-if="level4.isSelected"
																class="el-icon-check text-xs"
															/>
														</div>
													</li>
												</ul>
											</li>
										</ul>
									</li>
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { EventBus } from "../../eventBus";

export default {
	name: "BaseOrdersLocationsDD",
	// props: {
	// 	dropdownArray: {
	// 		type: Array,
	// 		required: true
	// 	}
	// },
	props: {
		accessLevel: {
			type: String,
			required: true
		},
		accessRegions: {
			type: Array,
			default: () => []
		},
		orderOutlets: {
			type: Array,
			default: () => []
		},
		accessCountry: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			// selected: [],
			// basics: ""
		};
	},
	computed: {
		...mapState("CommonStore", ["locations"]),
		orderlocations() {
			if (this.accessLevel === "region") {
				return this.locations
					.filter(this.filteroutRegions)
					.map(this.filterOutOrderOutlets);
			} else if (this.accessLevel === "super") {
				return this.locations
					.filter(this.filteroutCountries)
					.map(this.filterOutOrderOutlets);
			} else if (this.accessLevel === "admin") {
				return this.locations.map(this.filterOutOrderOutlets);
			} else {
				return this.locations;
			}
		},
		orderOutletsIds() {
			return this.orderOutlets.map(orderOutlet => orderOutlet.id);
		}
	},
	created() {
		this.getLocations();
		// this.sortDDUserWise();
	},
	mounted() {
		// console.log(this.locations);
	},
	methods: {
		...mapActions("CommonStore", ["getLocations"]),
		extractOutlets(event, selectedObj) {
			this.deSelectSelected(this.locations);
			// console.log(selectedObj);
			selectedObj.isSelected = true;
			var outlets = [];
			this.getOutlets(selectedObj, outlets);
			this.$emit("outlets", outlets);
		},
		getOutlets(selectedObj, outlets) {
			// console.log(selectedObj);
			if (
				typeof selectedObj === "object" &&
				selectedObj !== null &&
				selectedObj.type === "outlet"
			) {
				outlets.push({ id: selectedObj.id, name: selectedObj.name });
			}
			if (Array.isArray(selectedObj)) {
				selectedObj.forEach(obj => {
					this.getOutlets(obj, outlets);
				});
			} else {
				Object.keys(selectedObj).forEach(key => {
					if (Array.isArray(selectedObj[key])) {
						this.getOutlets(selectedObj[key], outlets);
					}
				});
			}
		},
		deSelectSelected(arr) {
			arr.forEach(obj => {
				obj.isSelected = false;
				Object.keys(obj).forEach(key => {
					if (Array.isArray(obj[key])) {
						this.deSelectSelected(obj[key]);
					}
				});
			});
		},
		filteroutCountries(countryObj) {
			// console.log("country id", countryObj.id);
			if (countryObj.id !== this.accessCountry) {
				return false;
			}
			return true;
		},
		filteroutRegions(countryObj) {
			if (!countryObj.regions.length) {
				return false;
			}
			countryObj.regions = countryObj.regions.filter(
				regionObj => this.accessRegions.indexOf(regionObj.id) > -1
			);
			return true;
		},
		filterOutOrderOutlets(obj) {
			// console.log("obnj", obj);
			// console.log(obj.hasOwnProperty("outlets") && obj.outlets.length > 0);
			if (obj.hasOwnProperty("outlets") && obj.outlets.length) {
				// console.log("inside if outlets has length");
				obj.outlets = obj.outlets.filter(
					outletObj => this.orderOutletsIds.indexOf(outletObj.id) > -1
				);
			}
			if (Array.isArray(obj)) {
				obj.forEach(obj => {
					this.filterOutOrderOutlets(obj);
				});
			} else {
				Object.keys(obj).forEach(key => {
					// console.log("key", key);
					if (Array.isArray(obj[key])) {
						this.filterOutOrderOutlets(obj[key]);
					}
				});
			}
			return obj;
		}

		// 	pushToSelectedArray(event, selectedObj) {
		// 		if (this.$route.name != "Category") {
		// 			EventBus.$emit("breadCrumbs", []);
		// 		}
		// 		// display array is selected array.
		// 		// push the selected obj to the display array to display the selected field,
		// 		// and also remove the selected field from the display area.
		// 		// and also remove the fields if basics field changes

		// 		// console.log("selectedObj", selectedObj);
		// 		this.basics = selectedObj.type; // set the basics so that other selected fields can be removed from display array

		// 		selectedObj.isSelected = !selectedObj.isSelected; // toggle selected field
		// 		if (selectedObj.isSelected) {
		// 			this.selected.push(selectedObj); // push selected field to display array.
		// 		} else {
		// 			this.removeElement(selectedObj); // remove field from the display array
		// 		}
		// 		const duplicateloc_selected = this.selected.slice(); // duplicate the display array
		// 		duplicateloc_selected.map(obj => {
		// 			// remove fields if basics field is changed
		// 			if (obj.type != this.basics) {
		// 				this.removeFromSelectedArray(obj);
		// 			}
		// 		});
		// 		this.$emit("update", { basics: this.basics, selected: this.selected });
		// 		// this.$store.commit("setLocSelected", this.selected);
		// 	},
		// 	removeFromSelectedArray(removedObj) {
		// 		if (this.$route.name != "Category") {
		// 			EventBus.$emit("breadCrumbs", []);
		// 		}
		// 		// reomove the selected field from dipslay array.
		// 		removedObj.isSelected = false; // make the selected field to false
		// 		this.removeElement(removedObj); // actual removal of field
		// 	},
		// 	removeElement(elementToRemove) {
		// 		// check each element in the array and remove the field.
		// 		this.selected.forEach((obj, i, arr) => {
		// 			if (obj.id === elementToRemove.id) {
		// 				arr.splice(arr.indexOf(obj), 1);
		// 			} // remove the selected value from the screen
		// 		});
		// 		this.$emit("update", { basics: this.basics, selected: this.selected });
		// 	}
	}
};
</script>

<style lang="scss" scoped>
@import "./BaseOrdersLocations";
</style>
